import { isAllTracking } from './gdprUtil';
import { isNoTrackView, isAcceptView } from '../commonUtil/util';

export const canLoadManifestDirect = (isDisabledGDPR, isExpired, isPasswordRequired, isWatermarkingRequired, hasPasswordCookie, hasCompliancePasswordCookie, isWatermarkEnabled) => {
    if (isDisabledGDPR || (isExpired && hasCompliancePasswordCookie)) {
        return true;
    }

    if ((isNoTrackView() || isAcceptView()) && !isPasswordRequired) {
        return true;
    }

    if (!isExpired && (!isWatermarkingRequired || isAllTracking(isWatermarkEnabled))) {
        return hasPasswordCookie || !isPasswordRequired;
    }

    return false;
};

export const canLoadWatermarkManifest = (isWatermarkingRequired, isExpired, isValidatedCompliancePassword, isLoadManifestDirect, isWatermarkEnabled) => {
    if (isWatermarkingRequired && !isLoadManifestDirect) {
        if (isNoTrackView() || isAcceptView()) {
            return true;
        }

        if (!isExpired && isAllTracking(isWatermarkEnabled)) {
            return true;
        }

        if (isExpired && isValidatedCompliancePassword) {
            return true;
        }
    }

    return false;
};
